import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ConfirmAction, Icon } from "MODULES/shared/components";
import { undoScrap } from "MODULES/inventories/actions";
import {
  AWAITING_SCRAP_REPORT_AT_SHOP,
  AWAITING_SCRAP_REPORT_LOCAL
} from "MODULES/inventories/constants";

function UndoScrap({ editing, close, onSubmit, inventory }) {
  const canUndoScrap = [
    AWAITING_SCRAP_REPORT_AT_SHOP,
    AWAITING_SCRAP_REPORT_LOCAL
  ].includes(inventory.get("status"));

  return (
    <ConfirmAction
      onConfirm={() => onSubmit(inventory.get("id"))}
      close={close}
      open={editing}
      icon={<Icon name="undo" fixed />}
      btnText="Undo Scrap"
      showButton={canUndoScrap}
    >
      <strong>Heads up!</strong>
      <br />
      <span>{"Are you sure you'd like to undo scrap?"}</span>
    </ConfirmAction>
  );
}

export default connect(undefined, dispatch => ({
  onSubmit: id => dispatch(undoScrap(id))
}))(UndoScrap);

UndoScrap.propTypes = {
  editing: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  inventory: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/UndoScrap/UndoScrap.jsx